import { render, staticRenderFns } from "./ThrottleMonitor.vue?vue&type=template&id=2277150a&scoped=true"
import script from "./ThrottleMonitor.vue?vue&type=script&lang=js"
export * from "./ThrottleMonitor.vue?vue&type=script&lang=js"
import style0 from "./ThrottleMonitor.vue?vue&type=style&index=0&id=2277150a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277150a",
  null
  
)

export default component.exports